(function () {

    /**
     * Rerun the cart initialization AFTER the monkeypatch is applied
     */
    function rerunCart() {
        //	console.log('FE:4016-non-latin-user-account-btn-clickable rerunCart()');
        if (!window['HPE_MINI_CART'] || !window['HPE_MINI_CART'].cfg) return;
        //set a couple of flags that prevent code from running a 2nd time
        window['HPE_MINI_CART'].cartInitialized = false
        window['HPE_MINI_CART'].cartCssInserted = false;
        window['HPE_MINI_CART'].init(window['HPE_MINI_CART'].cfg);//need to pass current config into the init()
    }

    /**
     * Replace all instances of a string in a string but do not use regex as that fails in non-latin languages
     * @param str
     * @param search
     * @param replace
     */
    var stableReplace = function (str, search, replace) {
        if (!str) return '';
        if (!search) return str;
        if (!replace) replace = '';
        return str.split(search).join(replace);
    }

    function init() {
        window['feHPEB2C'].log(`FE:4016-korean-user-account-btn-clickable.ts init()`);
        //	overrideAccountLink();
        // 	setTimeout(overrideAccountLink, 1000);
        // 	setTimeout(overrideAccountLink, 5000);

        window['HPE_MINI_CART'].replaceCSSForLocale = function () {
            if (!this.cfg) return;
            if (this.cfg.replace_css[this.ll]) {
                this.cfg.css = stableReplace(this.cfg.css, this.cfg.replace_css[this.ll]['search'], this.cfg.replace_css[this.ll]['replace']);
                //	this.cfg.css.replaceAll(new RegExp(this.cfg.replace_css[this.ll]['search'], 'ig'), this.cfg.replace_css[this.ll]['replace']);
            } else if (this.cfg.replace_css[this.ll + '-' + this.cc]) {
                this.cfg.css = stableReplace(this.cfg.css, this.cfg.replace_css[this.ll + '-' + this.cc]['search'], this.cfg.replace_css[this.ll + '-' + this.cc]['replace']);
                //	this.cfg.css = this.cfg.css.replaceAll(new RegExp(this.cfg.replace_css[this.ll + '-' + this.cc]['search'], 'ig'), this.cfg.replace_css[this.ll + '-' + this.cc]['replace']);
            }
        }
        setTimeout(rerunCart, 500);
    }

// HPE has /tw/zh pointed at /tw/en for the link to the account page so not really needed right now
    function pageIsReady() {
        return !!window['HPE_MINI_CART'];
    }

    window.feUtils.waitForConditions({
        conditions: ['body', pageIsReady],
        activity: feProjectId,
        callback: init,
    });
//    window['feUtils'].waitForConditions(['body', pageIsReady], init);
    window['feHPEB2C'].log(`FE:4016-korean-user-account-btn-clickable.ts loaded`);
})();


